import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

const PortfolioDetails = () => {

    const [active, setActive] = useState("All");
    const [categories, setCategories] = useState([]);
    const [projects, setProjects] = useState([]);

    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);


    /* =====================================================
     * FETCH CATEGORIES
     * ===================================================== */

    useEffect(() => {

        fetch(
            "https://codebuddys.in/wp-json/wp/v2/project-category"
        )
            .then((res) => res.json())
            .then((data) => {

                setCategories(data);

            })
            .catch((error) => {

                console.error(
                    "Category API Error:",
                    error
                );

            });

    }, []);


    /* =====================================================
     * FETCH PROJECTS
     * ===================================================== */

    useEffect(() => {

        fetch(
            "https://codebuddys.in/wp-json/wp/v2/projects?_embed&per_page=100"
        )
            .then((res) => res.json())
            .then((data) => {

                console.log(
                    "PROJECT DATA:",
                    data
                );

                setProjects(data);

            })
            .catch((error) => {

                console.error(
                    "Project API Error:",
                    error
                );

            });

    }, []);


    /* =====================================================
     * FILTER
     * ===================================================== */

    const filtered =
        active === "All"
            ? projects
            : projects.filter((project) => {

                const terms =
                    project._embedded?.["wp:term"] || [];

                const allCategories =
                    terms.flat();

                return allCategories.some(
                    (cat) =>
                        cat.id === active.id
                );

            });


    /* =====================================================
     * LIGHTBOX SLIDES
     * ===================================================== */

    const slides = filtered
        .map((item) => {

            const image =
                item._embedded
                    ?.["wp:featuredmedia"]
                    ?. [0]
                    ?.source_url;

            if (!image) {
                return null;
            }

            return {
                src: image
            };

        })
        .filter(Boolean);


    return (
        <div>


            {/* =================================================
             * PORTFOLIO
             * ================================================= */}

            <section className="portfolio-full">


                <h2
                    className="title"
                    style={{
                        margin: "0"
                    }}
                >
                    Work Showcase
                </h2>


                <p
                    style={{
                        textAlign: "center",
                        marginBottom: "50px"
                    }}
                >
                    Delivering impactful digital experiences
                    through design and development.
                </p>


                <div className="portfolio-wrapper">


                    {/* =========================================
                     * LEFT FILTER
                     * ========================================= */}

                    <div className="left-filter">


                        <h3
                            className={
                                active === "All"
                                    ? "active"
                                    : ""
                            }
                            onClick={() =>
                                setActive("All")
                            }
                        >
                            All
                        </h3>


                        {categories.map((cat) => (

                            <h3
                                key={cat.id}
                                className={
                                    active?.id === cat.id
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setActive(cat)
                                }
                            >
                                {cat.name}
                            </h3>

                        ))}

                    </div>


                    {/* =========================================
                     * RIGHT GRID
                     * ========================================= */}

                    <div className="right-grid masonry-grid">


                        {filtered.map((item, i) => {


                            /* IMAGE */

                            const img =
                                item._embedded
                                    ?.["wp:featuredmedia"]
                                    ?. [0]
                                    ?.source_url;


                            /* CATEGORIES */

                            const allTerms =
                                item._embedded
                                    ?.["wp:term"] || [];


                            const itemCategories =
                                allTerms.flat();


                            /* ZIP */

                            const zipUrl =
                                item.project_zip || "";


                            return (

                                <div
                                    className="card"
                                    key={item.id}
                                    onClick={() => {

                                        setIndex(i);

                                        setOpen(true);

                                    }}
                                >


                                    {/* BADGES */}

                                    <div className="badge-group">

                                        {itemCategories.map(
                                            (cat) => (

                                                <span
                                                    key={cat.id}
                                                    className="category-badge"
                                                >
                                                    {cat.name}
                                                </span>

                                            )
                                        )}

                                    </div>


                                    {/* IMAGE */}

                                    {img && (

                                        <img
                                            src={img}
                                            alt={
                                                item.title
                                                    ?.rendered ||
                                                "Project"
                                            }
                                        />

                                    )}


                                    {/* =================================
                                     * ZIP DOWNLOAD
                                     * ================================= */}

                                    {zipUrl && (

                                        <div
                                            className="project-zip-wrapper"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                            }}
                                        >

                                            <a
                                                href={zipUrl}
                                                className="project-zip-button"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                }}
                                            >


                                                <span className="project-zip-icon">
                                                    ZIP
                                                </span>


                                                <span className="project-zip-text">
                                                    Download Project ZIP
                                                </span>


                                                <span className="project-zip-arrow">
                                                    ↓
                                                </span>


                                            </a>

                                        </div>

                                    )}

                                </div>

                            );

                        })}

                    </div>

                </div>

            </section>


            {/* =================================================
             * LIGHTBOX
             * ================================================= */}

            <Lightbox
                open={open}
                close={() =>
                    setOpen(false)
                }
                index={index}
                slides={slides}
                plugins={[
                    Zoom
                ]}
            />


            {/* =================================================
             * ZIP ONLY CSS
             * ================================================= */}

            <style>{`

                .project-zip-wrapper {
                    width: 100%;
                    padding: 12px 14px 14px;
                    box-sizing: border-box;
                    background: #000;
                }


                .project-zip-button {
                    width: 100%;
                    min-height: 48px;

                    display: flex;
                    align-items: center;

                    gap: 10px;

                    padding: 8px 12px;

                    box-sizing: border-box;

                    background: #050505;

                    border: 1px solid #00b9c6;

                    border-radius: 5px;

                    color: #00b9c6;

                    text-decoration: none;

                    font-size: 14px;

                    font-weight: 600;

                    transition:
                        background 0.25s ease,
                        color 0.25s ease,
                        transform 0.25s ease;
                }


                .project-zip-button:hover {

                    background: #00b9c6;

                    color: #000;

                    transform:
                        translateY(-2px);
                }


                .project-zip-icon {

                    width: 30px;
                    height: 30px;

                    min-width: 30px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border: 1px solid currentColor;

                    border-radius: 4px;

                    font-size: 10px;

                    font-weight: 800;

                    letter-spacing: 0.5px;

                }


                .project-zip-text {

                    flex: 1;

                    line-height: 1.3;

                }


                .project-zip-arrow {

                    font-size: 20px;

                    line-height: 1;

                }


                @media (max-width: 768px) {

                    .project-zip-wrapper {

                        padding: 10px;

                    }


                    .project-zip-button {

                        min-height: 44px;

                        font-size: 13px;

                    }


                    .project-zip-icon {

                        width: 28px;

                        height: 28px;

                        min-width: 28px;

                    }

                }

            `}</style>


        </div>
    );
};


export default PortfolioDetails;